module.exports = __webpack_public_path__ + "fd10f09940d31afd724c9c78f092011c.pdf";